import { formatSecondsToHMS, formatTaiwanDate, formatTaiwanDateTime, formatTaiwanDateTimeAMPM, OrderId } from "../../utils";
import { roleConfig } from "../roleConfig";

export const DeliverDataColums = [
    { name: "司機編號", selector: row => row.id, key: "id" },
    { name: "公司", selector: row => row.company || "-", key: "company" },
    { name: "姓名", selector: row => row.name, key: "name", copyable: true },
    { name: "電話", selector: row => row.phone, key: "phone", copyable: true },
    {
        name: "Email", selector: row => <span data-tooltip-id="email-tooltip"
            data-tooltip-content={row.email}>{row.email}</span>, key: "email"
    },
    { name: "LINE ID", selector: row => row.lineId || "-", key: "lineId", copyable: true },
    {
        name: "角色",
        cell: row =>
            <span className={`badge ${row.role === roleConfig['員工'] ? "bg-info text-dark" : row.role === roleConfig['主管'] ? "bg-primary text-white" : row.role === roleConfig['財務'] ? "bg-success" : row.role === roleConfig['經理'] ? "bg-warning text-dark" : row.role === roleConfig['管理者'] ? "bg-warning text-dark" : row.role === roleConfig['協理'] ? "bg-danger  text-white" : "bg-secondary text-white"}`}>
                {row.role === roleConfig['員工'] ? "員工" : row.role === roleConfig['主管'] ? "主管" : row.role === roleConfig['財務'] ? "財務" : row.role === roleConfig['經理'] ? "經理" : row.role === roleConfig['管理者'] ? "管理者" : row.role === roleConfig['協理'] ? "協理" : "維護者"}
            </span>,
        key: "role"
    },
    { name: "狀態", cell: row => <span className={`badge ${row.status === 1 ? "bg-info text-dark" : row.status === 2 ? "bg-primary text-white" : "bg-danger  text-white"}`}>{row.status === 1 ? "在職" : row.status === 2 ? "停職" : "離職"}</span>, key: "status" },
];

export const OrderDataColums = [
    {
        name: "單號", cell: row => OrderId(row.id), key: "id",
    },
    { name: "姓名", selector: row => row.name, key: "name" },
    { name: "電話", selector: row => row.phone, key: "phone" },
    {
        name: "Email", selector: row => <span data-tooltip-id="email-tooltip"
            data-tooltip-content={row.email}>{row.email}</span>, key: "email"
    },
    { name: "送貨日期", selector: row => formatTaiwanDate(row.deliveryDate), key: "deliveryDate" },
    { name: "司機", selector: row => row.deliverName, key: "deliverName" },
    { name: "縣市", selector: row => row.addressCity, key: "addressCity" },
    { name: "鄉鎮區", selector: row => row.addressDistrict, key: "addressDistrict" },
    { name: "詳細地址", selector: row => row.addressDetailed, key: "addressDetailed" },
    { name: "家具數量", selector: row => row.furnitureCount, key: "furnitureCount" },
    { name: "總重量(kg)", selector: row => row.weight, key: "weight" },
    { name: "發票金額", selector: row => row.invoiceAmount, key: "invoiceAmount" },
    { name: "運費", selector: row => row.deliveryFee, key: "deliveryFee" },
    { name: "樓層服務", cell: row => <span className={`badge ${row.hasFloorService ? "bg-success" : "bg-warning text-dark"}`}>{Number(row.hasFloorService) ? "是" : "否"}</span>, key: "hasFloorService" },
    { name: "寄送狀態", cell: row => <span className={`badge ${row.isShipped ? "bg-success" : "bg-warning text-dark"}`}>{row.isShipped ? "已送達" : "未送達"}</span>, key: "isShipped" },
    { name: "審核狀態", cell: row => <span className={`badge ${row.status === 1 ? "bg-info text-dark" : row.status === 2 ? "bg-primary text-white" : "bg-danger  text-white"}`}>{row.status === 1 ? "已通過" : row.status === 2 ? "未通過" : "未審核"}</span>, key: "status" },
];

export const Deliver_OrderDataColums = [
    {
        name: "單號", cell: row => OrderId(row.id), key: "id"
    },
    { name: "姓名", selector: row => row.name, key: "name" },
    { name: "電話", selector: row => row.phone, key: "phone" },
    {
        name: "Email", selector: row => <span data-tooltip-id="email-tooltip"
            data-tooltip-content={row.email}>{row.email}</span>, key: "email"
    },
    { name: "送貨日期", selector: row => formatTaiwanDate(row.deliveryDate), key: "deliveryDate" },
    { name: "司機", selector: row => row.deliverName !== "" ? row.deliverName : "無", key: "deliverName" },
    { name: "縣市", selector: row => row.addressCity, key: "addressCity" },
    { name: "城鎮", selector: row => row.addressDistrict, key: "addressDistrict" },
    { name: "詳細地址", selector: row => row.addressDetailed, key: "addressDetailed" },
    { name: "家具數量", selector: row => row.furnitureCount, key: "furnitureCount" },
    { name: "寄送狀態", cell: row => <span className={`badge ${row.isShipped ? "bg-success" : "bg-warning text-dark"}`}>{row.isShipped ? "已送達" : "未送達"}</span>, key: "isShipped" },
    { name: "審核狀態", cell: row => <span className={`badge ${row.status === 1 ? "bg-info text-dark" : row.status === 2 ? "bg-primary text-white" : "bg-danger  text-white"}`}>{row.status === 1 ? "已通過" : row.status === 2 ? "未通過" : "未審核"}</span>, key: "status" },
];

export const RecordDataColums = [
    { name: "派送序號", selector: row => row.id, key: "id" },
    { name: "司機姓名", selector: row => row.deliverName, key: "deliverName" },
    { name: "運送日期", selector: row => formatTaiwanDate(row.deliveryDate), key: "deliveryDate" },
    {
        name: "訂單編號",
        selector: row => row.orderId.map(i => <span className={`badge bg-warning text-dark`}>{i}</span>),
        collapsible: true,
        maxLength: 3,
        key: "orderId"
    },
    {
        name: "GoogleMap", cell: row => <p data-tooltip-id="email-tooltip"
            data-tooltip-content={row.mapUrl}>{row.mapUrl}</p>,
        collapsible: true,
        maxLength: 30,
        key: "mapUrl",
        copyable: true
    },
    { name: "行駛時間", selector: row => formatSecondsToHMS(row.drivingTime), key: "drivingTime" },
    { name: "總重量(kg)", selector: row => row.weight, key: "weight" },
    { name: "總距離(km)", selector: row => row.drivingKm + ' km', key: "drivingKm" },
    { name: "最長總距離(km)", selector: row => row.longDrivingKm + ' km', key: "longDrivingKm" },
    { name: "減碳量", selector: row => row.carbonReduction, key: "carbonReduction" },
    { name: "狀態", cell: row => <span className={`badge ${row.status ? "bg-success" : "bg-warning text-dark"}`}>{row.status ? "已完成" : "待完成"}</span>, key: "status" },
];

export const DeliverAreaDataColums = [
    { name: "鄉鎮區", selector: row => row.district, key: "district" },
    { name: "城市", selector: row => row.city, key: "city" },
    {
        name: "運送日",
        selector: row => row.description,
        key: "description"
    },
    { name: "使用狀態", selector: row => <span className={`badge ${!row.available ? "bg-success" : "bg-warning text-dark"}`}>{!row.available ? "啟用" : "停用"}</span>, key: "available" },
]

export const StaffOrderDataColums = [
    { name: "編號", selector: row => row.id, key: "id" },
    { name: "公司", selector: row => row.company || "-", key: "company" },
    { name: "使用者", selector: row => row.name, key: "name" },
    {
        name: "手機號碼",
        selector: row => row.phone,
        key: "phone"
    },
    { name: "車牌", selector: row => row.plate, key: "plate" },
    { name: "家具數量", selector: row => row.furnitureCount, key: "furnitureCount" },
    { name: "開始時間", selector: row => formatTaiwanDateTimeAMPM(row.usedAt), key: "usedAt" },
    { name: "結束時間", selector: row => formatTaiwanDateTimeAMPM(row.finishAt), key: "finishAt" },
    { name: "還車時間", selector: row => formatTaiwanDateTimeAMPM(row.returnAt) || "-", key: "returnAt" },
    { name: "狀態", cell: row => <span className={`badge ${row.status === 1 ? "bg-success" : row.status === 2 ? "bg-dark" : "bg-warning text-dark"}`}>{row.status === 1 ? "已完成" : row.status === 2 ? "未審核" : "未完成"}</span>, key: "status" },
    { name: "送貨服務", cell: row => <span className={`badge ${row.category === 1 ? "bg-success" : "bg-dark text-white"}`}>{Number(row.category) === 1 ? "是" : "否"}</span>, key: "category" },
]

export const VehicleDataColumns = [
    { name: "司機", selector: row => row.employee || "-", key: "employee" },
    { name: "公司", selector: row => row.company || "-", key: "company" },
    { name: "車牌號", selector: row => row.plate, key: "plate" },
    { name: "車型", selector: row => row.model, key: "model" },
    { name: "噸數", selector: row => row.tonnage || "-", key: "tonnage" },
    // { name: "所屬員工 ID", selector: row => row.employeeId || "-", key: "employeeId" },
    { name: "升降尾門", selector: row => row.hasTailLift ? "是" : "否", key: "hasTailLift" },
]

export const TruckLoanApplicationDataColumns = [
    {
        name: '申請ID',
        key: 'id',
        // sortable: true,
    },
    {
        name: '申請日期',
        key: 'applicantDate',
        selector: (row) => row.applicantDate || formatTaiwanDateTime(row.createdAt),
        // sortable: true,
    },
    {
        name: '申請人',
        key: 'applicantName',
        selector: (row) => row.applicantName,
        cell: (row) => (
            <div>
                <strong>{row.applicantName}</strong>
                <br />
                <small className="text-muted">{row.department}</small>
            </div>
        ),
        // sortable: true,
    },
    {
        name: '派車單ID',
        key: 'deliverOrderId',
        // sortable: true,
    },
    {
        name: '車輛',
        key: 'vehicle',
        selector: (row) => row.vehicle?.plate || '-',
        cell: (row) => (
            <div>
                {row.vehicle?.plate || '-'}
                <br />
                <small className="text-muted">{row.vehicle?.model || '-'}</small>
            </div>
        ),
    },
    {
        name: '行駛地點',
        key: 'destination',
        selector: (row) => row.destination,
        collapsible: true,
        maxLength: 40,
    },
    {
        name: '用車時間',
        key: 'time',
        selector: (row) => `${formatTaiwanDateTimeAMPM(row.startAt)}~${formatTaiwanDateTimeAMPM(row.endAt)}`,
        cell: (row) => (
            <small>
                {formatTaiwanDateTimeAMPM(row.startAt)}
                <br />~ {formatTaiwanDateTimeAMPM(row.endAt)}
            </small>
        ),
        // sortable: true,
    },
    {
        name: '使用事由',
        key: 'purpose',
        selector: (row) => row.purpose,
        collapsible: true,
        maxLength: 40,
    },
]